'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return {
    components: components,
    methods: methods,
    computed: computed,
    directives: directives
  };
};

var methods = require('./mixins/methods');
var computed = require('./mixins/computed');
var directives = require('./mixins/directives');
var components = require('./mixins/components');


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/table.js